import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { useThemeMode } from '../../../../_metronic/partials'
import { TeamMemberDataTable } from './TeamMemberDataTable'
import { TeamRoleDataTable } from './TeamRoleDataTable'
import { PendingInviteesDataTable } from './PendingInviteesDataTable'
import { ReceivedInviteesDataTable } from './ReceivedInviteesDataTable'

const TeamUpdated = () => {
    const { formatMessage } = useIntl()
    const { mode } = useThemeMode()
    const [selectedSidebarId, setSelectedSidebarId] = useState(1)
    const initialSidebarOptions = [
        { tabTitle: formatMessage({ id: 'Members' }), id: 1 },
        { tabTitle: formatMessage({ id: 'Roles' }), id: 2 },
        { tabTitle: formatMessage({ id: 'Sent Invites' }), id: 3 },
        { tabTitle: formatMessage({ id: 'Received Invites' }), id: 4 },
    ]
    return (
        <div className='d-flex flex-md-row flex-column'>
            <div className='mb-9 sidebar-investor-db col-md-1 d-none d-md-flex ' style={{ width: '14%' }}>
                {initialSidebarOptions.map((sideTab) => (
                    <ul className='text-muted text-active-primary d-md-flex flex-column d-none align-items-left p-0 m-0 cursor-pointer '>
                        <li
                            className={`nav-link text-active-primary py-3 ps-3 d-flex align-items-center ${selectedSidebarId === sideTab.id
                                    ? '  border-top-0 border border-bottom-0 border-right-0 border-left-3 border-primary text-primary border-5'
                                    : ''
                                }`}
                            onClick={() => setSelectedSidebarId(sideTab.id)}
                        >
                            {formatMessage({ id: sideTab.tabTitle })}
                        </li>
                    </ul>
                ))}
            </div>

            <div className='mb-2 sidebar-investor-db col-md-1 d-flex d-md-none' style={{ width: '100%' }}>
                <div
                    className='d-md-none d-flex'
                    style={{
                        display: 'flex',
                        overflowX: 'scroll',
                        whiteSpace: 'nowrap',
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                    }}
                >
                    {initialSidebarOptions.map((sideTab: any) => (
                        <ul
                            key={sideTab.id}
                            className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 flex-nowrap mobile-tab-both my-md-0 mb-2 d-md-none'
                            style={{ display: 'flex', flexWrap: 'nowrap' }}
                        >
                            <li
                                className={`nav-link text-active-primary py-3 ps-3 d-flex align-items-center ${selectedSidebarId === sideTab.id
                                        ? 'border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                                        : ''
                                    }`}
                                onClick={() => setSelectedSidebarId(sideTab.id)}
                            >
                                {formatMessage({ id: sideTab.tabTitle })}
                            </li>
                        </ul>
                    ))}
                </div>
            </div>

            <div
                className={`d-flex mb-9 py-4 px-6 rounded-2 w-100 ${mode !== 'dark' ? 'bg-white' : ''}`}
                style={{ background: '#1e1e2d' }}
            >
                {selectedSidebarId === 1 && (
                    <div className='d-flex mt-3 flex-column w-100'>
                        <div className='w-100'>
                            <TeamMemberDataTable setSelectedSidebarId={setSelectedSidebarId} />
                        </div>
                    </div>
                )}
                {selectedSidebarId === 2 && (
                    <div className='d-flex mt-3 flex-column w-100'>
                        <div className='w-100'>
                            <TeamRoleDataTable />
                        </div>
                    </div>
                )}
                {selectedSidebarId === 3 && (
                    <div className='d-flex mt-3 flex-column w-100'>
                        <div className='w-100'>
                            <PendingInviteesDataTable />
                        </div>
                    </div>
                )}
                {selectedSidebarId === 4 && (
                    <div className='d-flex mt-3 flex-column w-100'>
                        <div className='w-100'>
                            <ReceivedInviteesDataTable />
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default TeamUpdated
